import {useTracking} from '@app/modules/tracking';
import {Box} from '@tempo/core';
import {LandingHorizontalRail, LandingHorizontalRailItem} from '@tempo/landing';

const IMG_SIZE = '185px';

export type RailItem = {
	src: string;
	trad?: string;
	link?: string;
	label?: string;
};
export const LandingRail: React.FC<{items: RailItem[]; imgSize?: string}> = ({
	items,
	imgSize = IMG_SIZE,
}) => {
	const {trackClick} = useTracking();
	return (
		<LandingHorizontalRail imgSize={imgSize}>
			{items.map(({trad, src, link, label}, i) => (
				<Box
					key={`${trad} ${i}`}
					onClick={trackClick({eventaction: 'discover', eventlabel: label})}
				>
					<LandingHorizontalRailItem
						size={imgSize}
						alt={trad}
						src={src}
						href={link}
					>
						{trad}
					</LandingHorizontalRailItem>
				</Box>
			))}
		</LandingHorizontalRail>
	);
};
